import React from 'react';

interface WrestlerDetailsHeadingInfoProps {
  name: string;
  description: string;
}

const DetailsHeadingInfo = ({
  name,
  description,
}: WrestlerDetailsHeadingInfoProps) => {
  return (
    <div>
      <h4 className="mb-[30px] text-xl">{name}</h4>
      <div className="text-text600 mb-10 text-left text-sm">{description}</div>
    </div>
  );
};

export default DetailsHeadingInfo;
